import React from 'react'
import css from './styles.module.scss'
import HeroTitle from 'components/typo/HeroTitle'
import Text from 'components/typo/Text'
import Image from 'components/shared/Image'
import Layout from 'components/shared/Layout'
import Button from 'src/components/shared/Button'
import classnames from 'classnames'

const SiteHeroWithImage = ({
  upperTitle,
  title,
  description,
  image,
  primaryButton,
  secondaryButton,
  features,
  logos,
  whiteCards,
  isHero,
}) => {
  const cx = classnames.bind(css)
  return (
    <div className={css.background}>
      <Layout type="wrapper">
        <div className={css.wrapper}>
          <div
            className={cx(css.header, {
              [css.isHeroWidth]: isHero,
              [css.notHeroWidth]: !isHero,
            })}
          >
            <Text className={css.upperTitle}>{upperTitle}</Text>
            <HeroTitle
              className={cx({
                [css.heroTitle]: isHero,
                [css.basicTitle]: !isHero,
              })}
              tag="h1"
            >
              {title}
            </HeroTitle>
            <Text className={css.description}>{description}</Text>
            {(primaryButton || secondaryButton) && (
              <div className={css.buttonsRow}>
                {primaryButton && primaryButton.link && (
                  <Button
                    theme={primaryButton.theme}
                    link={{
                      href: primaryButton.link.href,
                      target: primaryButton.link.target,
                    }}
                    buttonClassName={css.button}
                  >
                    {primaryButton.link.text}
                  </Button>
                )}
                {secondaryButton && secondaryButton.link && (
                  <Button
                    className={css.secondaryButton}
                    buttonClassName={css.button}
                    theme={secondaryButton.theme}
                    link={{
                      href: secondaryButton.link.href,
                      target: secondaryButton.link.target,
                    }}
                  >
                    {secondaryButton.link.text}
                  </Button>
                )}
              </div>
            )}
            <div className={css.featuresRow}>
              {features &&
                features.map((feature) => (
                  <div className={css.oneFeature} key={feature.id}>
                    <Image
                      className={css.featureIcon}
                      media={{ width: 16, height: 16 }}
                      fluid
                      {...feature.icon}
                      alt={
                        feature.icon?.media?.data?.attributes
                          ?.alternativeText ?? 'icon-image'
                      }
                    />
                    <Text className={css.featureTitle}>{feature.title}</Text>
                  </div>
                ))}
            </div>
            {logos && logos.length > 0 && (
              <div className={css.logosRow}>
                {logos.map((logo) => (
                  <Image
                    key={logo.id}
                    className={css.logo}
                    fluid
                    notAbsolute
                    {...logo}
                    alt={
                      logo?.media?.data?.attributes?.alternativeText ??
                      'logo-image'
                    }
                  />
                ))}
              </div>
            )}
            <div className={css.whiteCardsRow}>
              {whiteCards &&
                whiteCards.map((card) => (
                  <div className={css.whiteCard}>
                    <Text className={css.whiteCardTitle}>{card.title}</Text>
                    <Text className={css.whiteCardDescription}>
                      {card.text}
                    </Text>
                    <Image
                      key={card.id}
                      className={css.whiteCardlogo}
                      fluid
                      {...card.icon}
                      alt={
                        card?.icon?.media?.data?.attributes?.alternativeText ??
                        'logo-image'
                      }
                    />
                  </div>
                ))}
            </div>
          </div>
          <div className={css.imageContainer}>
            <Image
              className={css.image}
              fluid
              {...image}
              alt={
                image?.media?.data?.attributes?.alternativeText ?? 'hero-image'
              }
            />
          </div>
        </div>
      </Layout>
      <Image
        className={css.mobileImage}
        media={{ width: 32, height: 32 }}
        fluid
        {...image}
        alt={image?.media?.data?.attributes?.alternativeText ?? 'card-image'}
      />
    </div>
  )
}

export default SiteHeroWithImage
